import {CheckCircleOutline, ErrorOutline} from '@mui/icons-material';
import {TableRow, TableCell, Checkbox, Tooltip} from '@mui/material';
import React from 'react';
import {useTrovoConfig} from '../../../../../utils/config';

interface SampleRowProps {
    row: any;
    selected: boolean;
    onSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
    expId: string;
    showPeaks?: boolean;
    disabled?: boolean;
}

const SampleRow = ({row, selected, onSelect, expId, showPeaks = false, disabled = false}: SampleRowProps) => {
    const {user} = useTrovoConfig();

    return (
        <TableRow sx={{'& > *': {borderBottom: '0'}, bgcolor: selected ? '#dbdce273' : 'on-primary'}} hover>
            <TableCell sx={{width: 10}} />
            <TableCell padding="checkbox" sx={{cursor: expId === '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9' ? 'not-allowed' : ''}}>
                {row?.peaks < 1000 ? (
                    <Tooltip title="Sample cannot be chosen: Peaks < 1000">
                        <span>
                            <Checkbox checked={selected} onChange={onSelect} disabled />
                        </span>
                    </Tooltip>
                ) : (
                    <Checkbox
                        checked={selected}
                        onChange={onSelect}
                        disabled={disabled || user.cb_item_price_id?.includes('demo') || expId === '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9'}
                    />
                )}
            </TableCell>
            <TableCell align="left">{row?.name}</TableCell>
            <TableCell align="left">
                {row.files.every((f: any) => f.status === 'ready') ? (
                    <div>
                        <CheckCircleOutline color="disabled" sx={{fontSize: '18px'}} /> ready
                    </div>
                ) : (
                    <div>
                        <ErrorOutline color="error" sx={{fontSize: '18px'}} /> error
                    </div>
                )}
            </TableCell>
            {showPeaks && <TableCell align="right">{row.peaks}</TableCell>}
            {Object.entries(row?.other_categories)?.map(([k, c]: [string, any]) => (
                <TableCell key={k} align="left">
                    {c}
                </TableCell>
            ))}
        </TableRow>
    );
};

export default SampleRow;
